// extracted by mini-css-extract-plugin
module.exports = {"Introduction":"Introduction_Introduction__nrErd","paragraph":"Introduction_paragraph___gtae","cta":"Introduction_cta__Tucps"};